import { useRef } from 'react';
import { Text, Tooltip } from '~/components/granular';
import useTruncated from '~/hooks/useTruncated';
import { classNames } from '~/utils/styles';

const TRUNCATION_CLASS_NAMES = {
  1: 'truncate',
  2: 'line-clamp-2 wrap-break-word',
} as const;

interface TruncatedTextProps {
  maxLines?: keyof typeof TRUNCATION_CLASS_NAMES;
  value: string;
}

/** Text cut to `maxLines`, with the full value in a tooltip only when it is actually cut. */
export const TruncatedText = ({ maxLines = 1, value }: TruncatedTextProps) => {
  const textRef = useRef<HTMLElement>(null);
  const isTruncated = useTruncated(textRef, value);

  return (
    <Tooltip
      disabled={!isTruncated}
      side="top"
      trigger={
        <Text as="span" className={classNames('block min-w-0', TRUNCATION_CLASS_NAMES[maxLines])} ref={textRef}>
          {value}
        </Text>
      }
    >
      {value}
    </Tooltip>
  );
};
